/**
 * @generated SignedSource<<8af5b05ca20dce96f89715c524264b14>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Weekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY" | "%future added value";
export type summaryOneDeliveryOnboardingQuery$variables = Record<PropertyKey, never>;
export type summaryOneDeliveryOnboardingQuery$data = {
  readonly creditOffers: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly maxPerUser: number | null | undefined;
    readonly priceCents: number;
    readonly purchasable: boolean;
    readonly title: string;
  }>;
  readonly creditPlans: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly priceCents: number;
    readonly title: string;
  }>;
  readonly onedeliveryProfile: {
    readonly baceId: string;
    readonly deliveryWeekdays: ReadonlyArray<Weekday>;
    readonly preferredHub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly id: string;
        readonly name: string;
        readonly postalCode: string;
        readonly street: string;
      } | null | undefined;
    };
  } | null | undefined;
};
export type summaryOneDeliveryOnboardingQuery = {
  response: summaryOneDeliveryOnboardingQuery$data;
  variables: summaryOneDeliveryOnboardingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "credits",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceCents",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OnedeliveryProfile",
    "kind": "LinkedField",
    "name": "onedeliveryProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baceId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryWeekdays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "preferredHub",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditOffer",
    "kind": "LinkedField",
    "name": "creditOffers",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "purchasable",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditPlan",
    "kind": "LinkedField",
    "name": "creditPlans",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "summaryOneDeliveryOnboardingQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "summaryOneDeliveryOnboardingQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "b216109513ac20bd11c7c4e90028e3c9",
    "id": null,
    "metadata": {},
    "name": "summaryOneDeliveryOnboardingQuery",
    "operationKind": "query",
    "text": "query summaryOneDeliveryOnboardingQuery {\n  onedeliveryProfile {\n    baceId\n    deliveryWeekdays\n    preferredHub {\n      id\n      meta {\n        id\n        name\n        street\n        postalCode\n        city\n      }\n    }\n  }\n  creditOffers {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n    maxPerUser\n    purchasable\n  }\n  creditPlans {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n  }\n}\n"
  }
};
})();

(node as any).hash = "2792ab484c213025a2bb90e777082f2a";

export default node;
